import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateSeason = async (data) => {
  const url = `v1/orgs/${data.orgId}/seasons/${data.seasonId}`
  const formData = new FormData()

  formData.append('name', data.name)
  formData.append('startDate', data.startDate?.toISOString())
  formData.append('endDate', data.endDate?.toISOString())

  if (data.logoDataUri) {
    formData.append('logoDataUri', data.logoDataUri)
  }

  return await axiosInstance.patch(url, formData)
}

export default updateSeason
